import "./code.45afaf3b.js";


function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("egk2v", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a6221ab6e73dea07$export$2e2bcd8739ae039);

var $327k3 = parcelRequire("327k3");
var $a6221ab6e73dea07$export$2e2bcd8739ae039 = {
    __name: 'remote',
    setup (__props, { expose: __expose }) {
        __expose();
        const center = (0, $327k3.ref)('');
        const zoom = (0, $327k3.ref)(0);
        const messages = (0, $327k3.ref)([]);
        const iframe = (0, $327k3.ref)(null);
        (0, $327k3.onMounted)(()=>{
            registerMessageListener();
        });
        function sendPreviewFile(file) {
            if (!file) return;
            sendMessage({
                command: 'preview',
                file: file
            });
        }
        function sendPreviewURL(url) {
            sendMessage({
                command: 'preview',
                url: url
            });
        }
        function sendLevel(level) {
            sendMessage({
                command: 'level',
                level: level
            });
        }
        function getLevels(level) {
            sendMessage({
                command: 'levels'
            });
        }
        function sendBbox(bbox) {
            sendMessage({
                command: 'coordinates',
                bbox: bbox.split(',')
            });
        }
        function sendCenterAndZoom() {
            const [lng, lat] = center.value.split(',').map(parseFloat);
            sendMessage({
                command: 'coordinates',
                center: {
                    lng: lng,
                    lat: lat
                },
                zoom: parseInt(zoom.value, 10)
            });
        }
        function sendMessage(message) {
            messages.value.push({
                dir: 'out',
                data: message
            });
            iframe.value.contentWindow.postMessage(message, '*');
        }
        function registerMessageListener() {
            window.addEventListener('message', (e)=>{
                messages.value.push({
                    dir: 'in',
                    data: e.data
                });
            });
        }
        const __returned__ = {
            center: center,
            zoom: zoom,
            messages: messages,
            iframe: iframe,
            sendPreviewFile: sendPreviewFile,
            sendPreviewURL: sendPreviewURL,
            sendLevel: sendLevel,
            getLevels: getLevels,
            sendBbox: sendBbox,
            sendCenterAndZoom: sendCenterAndZoom,
            sendMessage: sendMessage,
            registerMessageListener: registerMessageListener,
            ref: $327k3.ref,
            onMounted: $327k3.onMounted
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("lObqm", function(module, exports) {

$parcel$export(module.exports, "render", () => $fe072117d6eb95af$export$b3890eb0ae9dca99);

var $327k3 = parcelRequire("327k3");
const $fe072117d6eb95af$var$_hoisted_1 = {
    key: 0
};
const $fe072117d6eb95af$var$_hoisted_2 = {
    class: "text-body-2"
};
const $fe072117d6eb95af$var$_hoisted_3 = {
    ref: "iframe",
    src: "/",
    width: "100%",
    frameborder: "0",
    class: "fill-height"
};
function $fe072117d6eb95af$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_expansion_panel_title = (0, $327k3.resolveComponent)("v-expansion-panel-title");
    const _component_v_text_field = (0, $327k3.resolveComponent)("v-text-field");
    const _component_v_expansion_panel_text = (0, $327k3.resolveComponent)("v-expansion-panel-text");
    const _component_v_expansion_panel = (0, $327k3.resolveComponent)("v-expansion-panel");
    const _component_v_btn = (0, $327k3.resolveComponent)("v-btn");
    const _component_v_file_input = (0, $327k3.resolveComponent)("v-file-input");
    const _component_v_expansion_panels = (0, $327k3.resolveComponent)("v-expansion-panels");
    const _component_v_col = (0, $327k3.resolveComponent)("v-col");
    const _component_v_row = (0, $327k3.resolveComponent)("v-row");
    const _component_v_main = (0, $327k3.resolveComponent)("v-main");
    const _component_v_app = (0, $327k3.resolveComponent)("v-app");
    return (0, $327k3.openBlock)(), (0, $327k3.createBlock)(_component_v_app, null, {
        default: (0, $327k3.withCtx)(()=>[
                (0, $327k3.createVNode)(_component_v_main, null, {
                    default: (0, $327k3.withCtx)(()=>[
                            (0, $327k3.createVNode)(_component_v_row, {
                                "no-gutters": "",
                                class: "fill-height overflow-hidden"
                            }, {
                                default: (0, $327k3.withCtx)(()=>[
                                        (0, $327k3.createVNode)(_component_v_col, {
                                            cols: "4",
                                            class: "pa-3 sidebar overflow-auto"
                                        }, {
                                            default: (0, $327k3.withCtx)(()=>[
                                                    _cache[13] || (_cache[13] = (0, $327k3.createElementVNode)("h1", {
                                                        class: "text-h5 mb-2"
                                                    }, "Test Remote API", -1)),
                                                    _cache[14] || (_cache[14] = (0, $327k3.createElementVNode)("p", null, "The Remote API allows you to embed and interact with the viewer.", -1)),
                                                    _cache[15] || (_cache[15] = (0, $327k3.createElementVNode)("p", null, [
                                                        (0, $327k3.createTextVNode)("Read the "),
                                                        (0, $327k3.createElementVNode)("a", {
                                                            href: "https://github.com/indoorequal/indoorequal.org#remote-command-api",
                                                            target: "_blank"
                                                        }, "remote API documentation"),
                                                        (0, $327k3.createTextVNode)(".")
                                                    ], -1)),
                                                    (0, $327k3.createVNode)(_component_v_expansion_panels, {
                                                        accordion: ""
                                                    }, {
                                                        default: (0, $327k3.withCtx)(()=>[
                                                                (0, $327k3.createVNode)(_component_v_expansion_panel, null, {
                                                                    default: (0, $327k3.withCtx)(()=>[
                                                                            (0, $327k3.createVNode)(_component_v_expansion_panel_title, null, {
                                                                                default: (0, $327k3.withCtx)(()=>[
                                                                                        ..._cache[2] || (_cache[2] = [
                                                                                            (0, $327k3.createTextVNode)("Set bbox", -1)
                                                                                        ])
                                                                                    ]),
                                                                                _: 1
                                                                            }),
                                                                            (0, $327k3.createVNode)(_component_v_expansion_panel_text, null, {
                                                                                default: (0, $327k3.withCtx)(()=>[
                                                                                        _cache[3] || (_cache[3] = (0, $327k3.createElementVNode)("p", null, [
                                                                                            (0, $327k3.createTextVNode)("Use "),
                                                                                            (0, $327k3.createElementVNode)("a", {
                                                                                                href: "http://bboxfinder.com/",
                                                                                                target: "_blank"
                                                                                            }, "bboxfinder.com")
                                                                                        ], -1)),
                                                                                        (0, $327k3.createVNode)(_component_v_text_field, {
                                                                                            label: "bbox",
                                                                                            placeholder: "1.971874,48.921259,2.299404,49.029990",
                                                                                            "onUpdate:modelValue": $setup.sendBbox
                                                                                        })
                                                                                    ]),
                                                                                _: 1
                                                                            })
                                                                        ]),
                                                                    _: 1
                                                                }),
                                                                (0, $327k3.createVNode)(_component_v_expansion_panel, null, {
                                                                    default: (0, $327k3.withCtx)(()=>[
                                                                            (0, $327k3.createVNode)(_component_v_expansion_panel_title, null, {
                                                                                default: (0, $327k3.withCtx)(()=>[
                                                                                        ..._cache[4] || (_cache[4] = [
                                                                                            (0, $327k3.createTextVNode)("Set center and zoom", -1)
                                                                                        ])
                                                                                    ]),
                                                                                _: 1
                                                                            }),
                                                                            (0, $327k3.createVNode)(_component_v_expansion_panel_text, null, {
                                                                                default: (0, $327k3.withCtx)(()=>[
                                                                                        _cache[6] || (_cache[6] = (0, $327k3.createElementVNode)("p", null, [
                                                                                            (0, $327k3.createTextVNode)("Use "),
                                                                                            (0, $327k3.createElementVNode)("a", {
                                                                                                href: "http://bboxfinder.com/",
                                                                                                target: "_blank"
                                                                                            }, "bboxfinder.com")
                                                                                        ], -1)),
                                                                                        (0, $327k3.createVNode)(_component_v_text_field, {
                                                                                            modelValue: $setup.center,
                                                                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.center = $event),
                                                                                            label: "Center",
                                                                                            placeholder: "2.134953,48.9638220"
                                                                                        }, null, 8, [
                                                                                            "modelValue"
                                                                                        ]),
                                                                                        (0, $327k3.createVNode)(_component_v_text_field, {
                                                                                            modelValue: $setup.zoom,
                                                                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.zoom = $event),
                                                                                            label: "Zoom",
                                                                                            placeholder: "2"
                                                                                        }, null, 8, [
                                                                                            "modelValue"
                                                                                        ]),
                                                                                        (0, $327k3.createVNode)(_component_v_btn, {
                                                                                            onClick: $setup.sendCenterAndZoom
                                                                                        }, {
                                                                                            default: (0, $327k3.withCtx)(()=>[
                                                                                                    ..._cache[5] || (_cache[5] = [
                                                                                                        (0, $327k3.createTextVNode)("Send", -1)
                                                                                                    ])
                                                                                                ]),
                                                                                            _: 1
                                                                                        })
                                                                                    ]),
                                                                                _: 1
                                                                            })
                                                                        ]),
                                                                    _: 1
                                                                }),
                                                                (0, $327k3.createVNode)(_component_v_expansion_panel, null, {
                                                                    default: (0, $327k3.withCtx)(()=>[
                                                                            (0, $327k3.createVNode)(_component_v_expansion_panel_title, null, {
                                                                                default: (0, $327k3.withCtx)(()=>[
                                                                                        ..._cache[7] || (_cache[7] = [
                                                                                            (0, $327k3.createTextVNode)("Set level", -1)
                                                                                        ])
                                                                                    ]),
                                                                                _: 1
                                                                            }),
                                                                            (0, $327k3.createVNode)(_component_v_expansion_panel_text, null, {
                                                                                default: (0, $327k3.withCtx)(()=>[
                                                                                        (0, $327k3.createVNode)(_component_v_text_field, {
                                                                                            label: "Level",
                                                                                            "onUpdate:modelValue": $setup.sendLevel
                                                                                        })
                                                                                    ]),
                                                                                _: 1
                                                                            })
                                                                        ]),
                                                                    _: 1
                                                                }),
                                                                (0, $327k3.createVNode)(_component_v_expansion_panel, null, {
                                                                    default: (0, $327k3.withCtx)(()=>[
                                                                            (0, $327k3.createVNode)(_component_v_expansion_panel_title, null, {
                                                                                default: (0, $327k3.withCtx)(()=>[
                                                                                        ..._cache[8] || (_cache[8] = [
                                                                                            (0, $327k3.createTextVNode)("Get levels", -1)
                                                                                        ])
                                                                                    ]),
                                                                                _: 1
                                                                            }),
                                                                            (0, $327k3.createVNode)(_component_v_expansion_panel_text, null, {
                                                                                default: (0, $327k3.withCtx)(()=>[
                                                                                        (0, $327k3.createVNode)(_component_v_btn, {
                                                                                            onClick: $setup.getLevels
                                                                                        }, {
                                                                                            default: (0, $327k3.withCtx)(()=>[
                                                                                                    ..._cache[9] || (_cache[9] = [
                                                                                                        (0, $327k3.createTextVNode)("Get levels", -1)
                                                                                                    ])
                                                                                                ]),
                                                                                            _: 1
                                                                                        })
                                                                                    ]),
                                                                                _: 1
                                                                            })
                                                                        ]),
                                                                    _: 1
                                                                }),
                                                                (0, $327k3.createVNode)(_component_v_expansion_panel, null, {
                                                                    default: (0, $327k3.withCtx)(()=>[
                                                                            (0, $327k3.createVNode)(_component_v_expansion_panel_title, null, {
                                                                                default: (0, $327k3.withCtx)(()=>[
                                                                                        ..._cache[10] || (_cache[10] = [
                                                                                            (0, $327k3.createTextVNode)("Open preview with URL", -1)
                                                                                        ])
                                                                                    ]),
                                                                                _: 1
                                                                            }),
                                                                            (0, $327k3.createVNode)(_component_v_expansion_panel_text, null, {
                                                                                default: (0, $327k3.withCtx)(()=>[
                                                                                        (0, $327k3.createVNode)(_component_v_text_field, {
                                                                                            label: "Preview URL",
                                                                                            "onUpdate:modelValue": $setup.sendPreviewURL
                                                                                        })
                                                                                    ]),
                                                                                _: 1
                                                                            })
                                                                        ]),
                                                                    _: 1
                                                                }),
                                                                (0, $327k3.createVNode)(_component_v_expansion_panel, null, {
                                                                    default: (0, $327k3.withCtx)(()=>[
                                                                            (0, $327k3.createVNode)(_component_v_expansion_panel_title, null, {
                                                                                default: (0, $327k3.withCtx)(()=>[
                                                                                        ..._cache[11] || (_cache[11] = [
                                                                                            (0, $327k3.createTextVNode)("Open preview with file", -1)
                                                                                        ])
                                                                                    ]),
                                                                                _: 1
                                                                            }),
                                                                            (0, $327k3.createVNode)(_component_v_expansion_panel_text, null, {
                                                                                default: (0, $327k3.withCtx)(()=>[
                                                                                        (0, $327k3.createVNode)(_component_v_file_input, {
                                                                                            accept: ".osm,.geojson,.zip",
                                                                                            label: "File input for preview",
                                                                                            "onUpdate:modelValue": $setup.sendPreviewFile
                                                                                        })
                                                                                    ]),
                                                                                _: 1
                                                                            })
                                                                        ]),
                                                                    _: 1
                                                                })
                                                            ]),
                                                        _: 1
                                                    }),
                                                    $setup.messages.length > 0 ? ((0, $327k3.openBlock)(), (0, $327k3.createElementBlock)("div", $fe072117d6eb95af$var$_hoisted_1, [
                                                        _cache[12] || (_cache[12] = (0, $327k3.createElementVNode)("h2", {
                                                            class: "text-h6 my-2"
                                                        }, "Messages", -1)),
                                                        ((0, $327k3.openBlock)(true), (0, $327k3.createElementBlock)((0, $327k3.Fragment), null, (0, $327k3.renderList)($setup.messages, (message)=>{
                                                            return (0, $327k3.openBlock)(), (0, $327k3.createElementBlock)("div", $fe072117d6eb95af$var$_hoisted_2, (0, $327k3.toDisplayString)(message.dir === 'in' ? '<' : '>') + " " + (0, $327k3.toDisplayString)(message.data), 1);
                                                        }), 256))
                                                    ])) : (0, $327k3.createCommentVNode)("", true)
                                                ]),
                                            _: 1
                                        }),
                                        (0, $327k3.createVNode)(_component_v_col, null, {
                                            default: (0, $327k3.withCtx)(()=>[
                                                    (0, $327k3.createElementVNode)("iframe", $fe072117d6eb95af$var$_hoisted_3, null, 512)
                                                ]),
                                            _: 1
                                        })
                                    ]),
                                _: 1
                            })
                        ]),
                    _: 1
                })
            ]),
        _: 1
    });
}

});

parcelRegister("g6RW8", function(module, exports) {

$parcel$export(module.exports, "default", () => $bba70b948698ae89$export$2e2bcd8739ae039);
let $bba70b948698ae89$var$NOOP = ()=>{};
var $bba70b948698ae89$export$2e2bcd8739ae039 = (script)=>{};

});



var $327k3 = parcelRequire("327k3");

var $5Tl4B = parcelRequire("5Tl4B");

var $iF5x2 = parcelRequire("iF5x2");

var $79JPe = parcelRequire("79JPe");

var $4IyVK = parcelRequire("4IyVK");

var $4kufB = parcelRequire("4kufB");

var $fsPFg = parcelRequire("fsPFg");

var $cdMxz = parcelRequire("cdMxz");

var $327k3 = parcelRequire("327k3");

// Types
const $a709e3240ad74825$export$d2f18f636bf00f54 = Symbol.for('vuetify:v-expansion-panel');



var $327k3 = parcelRequire("327k3");


var $327k3 = parcelRequire("327k3");


var $emb8b = parcelRequire("emb8b");

var $9W37a = parcelRequire("9W37a");

var $cJqEc = parcelRequire("cJqEc");

var $jTudE = parcelRequire("jTudE");
var $58SaI = parcelRequire("58SaI");
var $djNVB = parcelRequire("djNVB");
const $61d0772cdd1f944d$export$f3c5154392bfd2e6 = (0, $58SaI.propsFactory)({
    ...(0, $9W37a.makeComponentProps)(),
    ...(0, $cJqEc.makeLazyProps)()
}, 'VExpansionPanelText');
const $61d0772cdd1f944d$export$98a17388a19b123f = (0, $jTudE.genericComponent)()({
    name: 'VExpansionPanelText',
    props: $61d0772cdd1f944d$export$f3c5154392bfd2e6(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const expansionPanel = (0, $327k3.inject)((0, $a709e3240ad74825$export$d2f18f636bf00f54));
        if (!expansionPanel) throw new Error('[Vuetify] v-expansion-panel-text needs to be placed inside v-expansion-panel');
        const { hasContent: hasContent, onAfterLeave: onAfterLeave } = (0, $cJqEc.useLazy)(props, expansionPanel.isSelected);
        (0, $djNVB.useRender)(()=>(0, $327k3.createVNode)((0, $emb8b.VExpandTransition), {
                "onAfterLeave": onAfterLeave
            }, {
                default: ()=>[
                        (0, $327k3.withDirectives)((0, $327k3.createElementVNode)("div", {
                            "class": (0, $327k3.normalizeClass)([
                                'v-expansion-panel-text',
                                props.class
                            ]),
                            "style": (0, $327k3.normalizeStyle)(props.style)
                        }, [
                            slots.default && hasContent.value && (0, $327k3.createElementVNode)("div", {
                                "class": "v-expansion-panel-text__wrapper"
                            }, [
                                slots.default?.()
                            ])
                        ]), [
                            [
                                (0, $327k3.vShow),
                                expansionPanel.isSelected.value
                            ]
                        ])
                    ]
            }));
        return {};
    }
});



var $327k3 = parcelRequire("327k3");


var $2mAl8 = parcelRequire("2mAl8");

var $cdMxz = parcelRequire("cdMxz");

var $1Vp3U = parcelRequire("1Vp3U");

var $9W37a = parcelRequire("9W37a");

var $2fujh = parcelRequire("2fujh");

var $jjnP7 = parcelRequire("jjnP7");

var $hiO7o = parcelRequire("hiO7o");

var $jTudE = parcelRequire("jTudE");
var $58SaI = parcelRequire("58SaI");
var $djNVB = parcelRequire("djNVB");
const $5f7130367f86d28a$export$85e1bc773c647163 = (0, $58SaI.propsFactory)({
    color: String,
    expandIcon: {
        type: (0, $jjnP7.IconValue),
        default: '$expand'
    },
    collapseIcon: {
        type: (0, $jjnP7.IconValue),
        default: '$collapse'
    },
    hideActions: Boolean,
    focusable: Boolean,
    static: Boolean,
    ripple: {
        type: [
            Boolean,
            Object
        ],
        default: false
    },
    readonly: Boolean,
    ...(0, $9W37a.makeComponentProps)(),
    ...(0, $2fujh.makeDimensionProps)()
}, 'VExpansionPanelTitle');
const $5f7130367f86d28a$export$4188f36ee8a3fb9e = (0, $jTudE.genericComponent)()({
    name: 'VExpansionPanelTitle',
    directives: {
        vRipple: $hiO7o.default
    },
    props: $5f7130367f86d28a$export$85e1bc773c647163(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const expansionPanel = (0, $327k3.inject)((0, $a709e3240ad74825$export$d2f18f636bf00f54));
        if (!expansionPanel) throw new Error('[Vuetify] v-expansion-panel-title needs to be placed inside v-expansion-panel');
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $1Vp3U.useBackgroundColor)(()=>props.color);
        const { dimensionStyles: dimensionStyles } = (0, $2fujh.useDimension)(props);
        const slotProps = (0, $327k3.computed)(()=>({
                collapseIcon: props.collapseIcon,
                disabled: expansionPanel.disabled.value,
                expanded: expansionPanel.isSelected.value,
                expandIcon: props.expandIcon,
                readonly: props.readonly
            }));
        const icon = (0, $327k3.toRef)(()=>expansionPanel.isSelected.value ? props.collapseIcon : props.expandIcon);
        (0, $djNVB.useRender)(()=>(0, $327k3.withDirectives)((0, $327k3.createElementVNode)("button", {
                "class": (0, $327k3.normalizeClass)([
                    'v-expansion-panel-title',
                    {
                        'v-expansion-panel-title--active': expansionPanel.isSelected.value,
                        'v-expansion-panel-title--focusable': props.focusable,
                        'v-expansion-panel-title--static': props.static
                    },
                    backgroundColorClasses.value,
                    props.class
                ]),
                "style": (0, $327k3.normalizeStyle)([
                    backgroundColorStyles.value,
                    dimensionStyles.value,
                    props.style
                ]),
                "type": "button",
                "tabindex": expansionPanel.disabled.value ? -1 : undefined,
                "disabled": expansionPanel.disabled.value,
                "aria-expanded": expansionPanel.isSelected.value,
                "onClick": !props.readonly ? expansionPanel.toggle : undefined
            }, [
                (0, $327k3.createElementVNode)("span", {
                    "class": "v-expansion-panel-title__overlay"
                }, null),
                slots.default?.(slotProps.value),
                !props.hideActions && (0, $327k3.createVNode)((0, $2mAl8.VDefaultsProvider), {
                    "defaults": {
                        VIcon: {
                            icon: icon.value
                        }
                    }
                }, {
                    default: ()=>[
                            (0, $327k3.createElementVNode)("span", {
                                "class": "v-expansion-panel-title__icon"
                            }, [
                                slots.actions?.(slotProps.value) ?? (0, $327k3.createVNode)((0, $cdMxz.VIcon), null, null)
                            ])
                        ]
                })
            ]), [
                [
                    (0, $hiO7o.default),
                    props.ripple
                ]
            ]));
        return {};
    }
});



var $2mAl8 = parcelRequire("2mAl8");

var $1Vp3U = parcelRequire("1Vp3U");

var $ae17V = parcelRequire("ae17V");

var $4samp = parcelRequire("4samp");

var $TGYWR = parcelRequire("TGYWR");

var $dQTee = parcelRequire("dQTee");

var $jTudE = parcelRequire("jTudE");
var $58SaI = parcelRequire("58SaI");
var $djNVB = parcelRequire("djNVB");
const $bdced8b715282960$export$957957cd07e373a6 = (0, $58SaI.propsFactory)({
    title: String,
    text: String,
    bgColor: String,
    ...(0, $ae17V.makeElevationProps)(),
    ...(0, $4samp.makeGroupItemProps)(),
    ...(0, $TGYWR.makeRoundedProps)(),
    ...(0, $dQTee.makeTagProps)(),
    ...(0, $5f7130367f86d28a$export$85e1bc773c647163)(),
    ...(0, $61d0772cdd1f944d$export$f3c5154392bfd2e6)()
}, 'VExpansionPanel');
const $bdced8b715282960$export$ee93fd2a8131fa1c = (0, $jTudE.genericComponent)()({
    name: 'VExpansionPanel',
    props: $bdced8b715282960$export$957957cd07e373a6(),
    emits: {
        'group:selected': (val)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const groupItem = (0, $4samp.useGroupItem)(props, (0, $a709e3240ad74825$export$d2f18f636bf00f54));
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $1Vp3U.useBackgroundColor)(()=>props.bgColor);
        const { elevationClasses: elevationClasses } = (0, $ae17V.useElevation)(props);
        const { roundedClasses: roundedClasses } = (0, $TGYWR.useRounded)(props);
        const isDisabled = (0, $327k3.toRef)(()=>groupItem?.disabled.value || props.disabled);
        const selectedIndices = (0, $327k3.computed)(()=>groupItem.group.items.value.reduce((arr, item, index)=>{
                if (groupItem.group.selected.value.includes(item.id)) arr.push(index);
                return arr;
            }, []));
        const isBeforeSelected = (0, $327k3.computed)(()=>{
            const index = groupItem.group.items.value.findIndex((item)=>item.id === groupItem.id);
            return !groupItem.isSelected.value && selectedIndices.value.some((selectedIndex)=>selectedIndex - index === 1);
        });
        const isAfterSelected = (0, $327k3.computed)(()=>{
            const index = groupItem.group.items.value.findIndex((item)=>item.id === groupItem.id);
            return !groupItem.isSelected.value && selectedIndices.value.some((selectedIndex)=>selectedIndex - index === -1);
        });
        (0, $327k3.provide)((0, $a709e3240ad74825$export$d2f18f636bf00f54), groupItem);
        (0, $djNVB.useRender)(()=>{
            const hasText = !!(slots.text || props.text);
            const hasTitle = !!(slots.title || props.title);
            const expansionPanelTitleProps = (0, $5f7130367f86d28a$export$4188f36ee8a3fb9e).filterProps(props);
            const expansionPanelTextProps = (0, $61d0772cdd1f944d$export$98a17388a19b123f).filterProps(props);
            return (0, $327k3.createVNode)(props.tag, {
                "class": (0, $327k3.normalizeClass)([
                    'v-expansion-panel',
                    {
                        'v-expansion-panel--active': groupItem.isSelected.value,
                        'v-expansion-panel--before-active': isBeforeSelected.value,
                        'v-expansion-panel--after-active': isAfterSelected.value,
                        'v-expansion-panel--disabled': isDisabled.value
                    },
                    roundedClasses.value,
                    backgroundColorClasses.value,
                    props.class
                ]),
                "style": (0, $327k3.normalizeStyle)([
                    backgroundColorStyles.value,
                    props.style
                ])
            }, {
                default: ()=>[
                        (0, $327k3.createElementVNode)("div", {
                            "class": (0, $327k3.normalizeClass)([
                                'v-expansion-panel__shadow',
                                ...elevationClasses.value
                            ])
                        }, null),
                        (0, $327k3.createVNode)((0, $2mAl8.VDefaultsProvider), {
                            "defaults": {
                                VExpansionPanelTitle: {
                                    ...expansionPanelTitleProps
                                },
                                VExpansionPanelText: {
                                    ...expansionPanelTextProps
                                }
                            }
                        }, {
                            default: ()=>[
                                    hasTitle && (0, $327k3.createVNode)((0, $5f7130367f86d28a$export$4188f36ee8a3fb9e), {
                                        "key": "title"
                                    }, {
                                        default: ()=>[
                                                slots.title ? slots.title() : props.title
                                            ]
                                    }),
                                    hasText && (0, $327k3.createVNode)((0, $61d0772cdd1f944d$export$98a17388a19b123f), {
                                        "key": "text"
                                    }, {
                                        default: ()=>[
                                                slots.text ? slots.text() : props.text
                                            ]
                                    }),
                                    slots.default?.()
                                ]
                        })
                    ]
            });
        });
        return {
            groupItem: groupItem
        };
    }
});



var $9W37a = parcelRequire("9W37a");

var $hctXS = parcelRequire("hctXS");

var $4samp = parcelRequire("4samp");

var $dQTee = parcelRequire("dQTee");

var $1vMWa = parcelRequire("1vMWa");

var $jTudE = parcelRequire("jTudE");
var $iMwle = parcelRequire("iMwle");
var $58SaI = parcelRequire("58SaI");
var $djNVB = parcelRequire("djNVB");
const $e307ffff509aed5a$var$allowedVariants = [
    'default',
    'accordion',
    'inset',
    'popout'
];
const $e307ffff509aed5a$export$d02e8e924ebac11d = (0, $58SaI.propsFactory)({
    flat: Boolean,
    ...(0, $4samp.makeGroupProps)(),
    ...(0, $iMwle.pick)((0, $bdced8b715282960$export$957957cd07e373a6)(), [
        'bgColor',
        'collapseIcon',
        'color',
        'eager',
        'elevation',
        'expandIcon',
        'focusable',
        'hideActions',
        'readonly',
        'ripple',
        'rounded',
        'tile',
        'static'
    ]),
    ...(0, $1vMWa.makeThemeProps)(),
    ...(0, $9W37a.makeComponentProps)(),
    ...(0, $dQTee.makeTagProps)(),
    variant: {
        type: String,
        default: 'default',
        validator: (v)=>$e307ffff509aed5a$var$allowedVariants.includes(v)
    }
}, 'VExpansionPanels');
const $e307ffff509aed5a$export$1d655deb4215c753 = (0, $jTudE.genericComponent)()({
    name: 'VExpansionPanels',
    props: $e307ffff509aed5a$export$d02e8e924ebac11d(),
    emits: {
        'update:modelValue': (val)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { next: next, prev: prev } = (0, $4samp.useGroup)(props, (0, $a709e3240ad74825$export$d2f18f636bf00f54));
        const { themeClasses: themeClasses } = (0, $1vMWa.provideTheme)(props);
        const variantClass = (0, $327k3.toRef)(()=>props.variant && `v-expansion-panels--variant-${props.variant}`);
        (0, $hctXS.provideDefaults)({
            VExpansionPanel: {
                bgColor: (0, $327k3.toRef)(()=>props.bgColor),
                collapseIcon: (0, $327k3.toRef)(()=>props.collapseIcon),
                color: (0, $327k3.toRef)(()=>props.color),
                eager: (0, $327k3.toRef)(()=>props.eager),
                elevation: (0, $327k3.toRef)(()=>props.elevation),
                expandIcon: (0, $327k3.toRef)(()=>props.expandIcon),
                focusable: (0, $327k3.toRef)(()=>props.focusable),
                hideActions: (0, $327k3.toRef)(()=>props.hideActions),
                readonly: (0, $327k3.toRef)(()=>props.readonly),
                ripple: (0, $327k3.toRef)(()=>props.ripple),
                rounded: (0, $327k3.toRef)(()=>props.rounded),
                static: (0, $327k3.toRef)(()=>props.static)
            }
        });
        (0, $djNVB.useRender)(()=>(0, $327k3.createVNode)(props.tag, {
                "class": (0, $327k3.normalizeClass)([
                    'v-expansion-panels',
                    {
                        'v-expansion-panels--flat': props.flat,
                        'v-expansion-panels--tile': props.tile
                    },
                    themeClasses.value,
                    variantClass.value,
                    props.class
                ]),
                "style": (0, $327k3.normalizeStyle)(props.style)
            }, {
                default: ()=>[
                        slots.default?.({
                            prev: prev,
                            next: next
                        })
                    ]
            }));
        return {
            next: next,
            prev: prev
        };
    }
});





// Styles


var $9W37a = parcelRequire("9W37a");

var $8MrXO = parcelRequire("8MrXO");

var $dQTee = parcelRequire("dQTee");

var $327k3 = parcelRequire("327k3");

var $jTudE = parcelRequire("jTudE");
var $58SaI = parcelRequire("58SaI");
const $54e16c7e9e688100$var$ALIGNMENT = [
    'start',
    'end',
    'center'
];
const $54e16c7e9e688100$var$SPACE = [
    'space-between',
    'space-around',
    'space-evenly'
];
function $54e16c7e9e688100$var$makeRowProps(prefix, def) {
    return (0, $8MrXO.breakpoints).reduce((props, val)=>{
        const prefixKey = prefix + (0, $327k3.capitalize)(val);
        props[prefixKey] = def();
        return props;
    }, {});
}
const $54e16c7e9e688100$var$ALIGN_VALUES = [
    ...$54e16c7e9e688100$var$ALIGNMENT,
    'baseline',
    'stretch'
];
const $54e16c7e9e688100$var$alignValidator = (str)=>$54e16c7e9e688100$var$ALIGN_VALUES.includes(str);
const $54e16c7e9e688100$var$alignProps = $54e16c7e9e688100$var$makeRowProps('align', ()=>({
        type: String,
        default: null,
        validator: $54e16c7e9e688100$var$alignValidator
    }));
const $54e16c7e9e688100$var$JUSTIFY_VALUES = [
    ...$54e16c7e9e688100$var$ALIGNMENT,
    ...$54e16c7e9e688100$var$SPACE
];
const $54e16c7e9e688100$var$justifyValidator = (str)=>$54e16c7e9e688100$var$JUSTIFY_VALUES.includes(str);
const $54e16c7e9e688100$var$justifyProps = $54e16c7e9e688100$var$makeRowProps('justify', ()=>({
        type: String,
        default: null,
        validator: $54e16c7e9e688100$var$justifyValidator
    }));
const $54e16c7e9e688100$var$ALIGN_CONTENT_VALUES = [
    ...$54e16c7e9e688100$var$ALIGNMENT,
    ...$54e16c7e9e688100$var$SPACE,
    'stretch'
];
const $54e16c7e9e688100$var$alignContentValidator = (str)=>$54e16c7e9e688100$var$ALIGN_CONTENT_VALUES.includes(str);
const $54e16c7e9e688100$var$alignContentProps = $54e16c7e9e688100$var$makeRowProps('alignContent', ()=>({
        type: String,
        default: null,
        validator: $54e16c7e9e688100$var$alignContentValidator
    }));
const $54e16c7e9e688100$var$propMap = {
    align: Object.keys($54e16c7e9e688100$var$alignProps),
    justify: Object.keys($54e16c7e9e688100$var$justifyProps),
    alignContent: Object.keys($54e16c7e9e688100$var$alignContentProps)
};
const $54e16c7e9e688100$var$classMap = {
    align: 'align',
    justify: 'justify',
    alignContent: 'align-content'
};
function $54e16c7e9e688100$var$breakpointClass(type, prop, val) {
    let className = $54e16c7e9e688100$var$classMap[type];
    if (val == null) return undefined;
    if (prop) {
        // alignSm -> Sm
        const breakpoint = prop.replace(type, '');
        className += `-${breakpoint}`;
    }
    // .align-items-sm-center
    className += `-${val}`;
    return className.toLowerCase();
}
const $54e16c7e9e688100$export$aa6139b66bca50c0 = (0, $58SaI.propsFactory)({
    dense: Boolean,
    noGutters: Boolean,
    align: {
        type: String,
        default: null,
        validator: $54e16c7e9e688100$var$alignValidator
    },
    ...$54e16c7e9e688100$var$alignProps,
    justify: {
        type: String,
        default: null,
        validator: $54e16c7e9e688100$var$justifyValidator
    },
    ...$54e16c7e9e688100$var$justifyProps,
    alignContent: {
        type: String,
        default: null,
        validator: $54e16c7e9e688100$var$alignContentValidator
    },
    ...$54e16c7e9e688100$var$alignContentProps,
    ...(0, $9W37a.makeComponentProps)(),
    ...(0, $dQTee.makeTagProps)()
}, 'VRow');
const $54e16c7e9e688100$export$978f7f00e11cd63 = (0, $jTudE.genericComponent)()({
    name: 'VRow',
    props: $54e16c7e9e688100$export$aa6139b66bca50c0(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const classes = (0, $327k3.computed)(()=>{
            const classList = [];
            // Loop through `align`, `justify`, `alignContent` breakpoint props
            let type;
            for(type in $54e16c7e9e688100$var$propMap)$54e16c7e9e688100$var$propMap[type].forEach((prop)=>{
                const value = props[prop];
                const className = $54e16c7e9e688100$var$breakpointClass(type, prop, value);
                if (className) classList.push(className);
            });
            classList.push({
                'v-row--no-gutters': props.noGutters,
                'v-row--dense': props.dense,
                [`align-${props.align}`]: props.align,
                [`justify-${props.justify}`]: props.justify,
                [`align-content-${props.alignContent}`]: props.alignContent
            });
            return classList;
        });
        return ()=>(0, $327k3.h)(props.tag, {
                class: [
                    'v-row',
                    classes.value,
                    props.class
                ],
                style: props.style
            }, slots.default?.());
    }
});


// Styles


var $9W37a = parcelRequire("9W37a");

var $8MrXO = parcelRequire("8MrXO");

var $dQTee = parcelRequire("dQTee");

var $327k3 = parcelRequire("327k3");

var $jTudE = parcelRequire("jTudE");
var $58SaI = parcelRequire("58SaI");
const $4359d614e864bb71$var$breakpointProps = (()=>{
    return (0, $8MrXO.breakpoints).reduce((props, val)=>{
        props[val] = {
            type: [
                Boolean,
                String,
                Number
            ],
            default: false
        };
        return props;
    }, {});
})();
const $4359d614e864bb71$var$offsetProps = (()=>{
    return (0, $8MrXO.breakpoints).reduce((props, val)=>{
        const offsetKey = 'offset' + (0, $327k3.capitalize)(val);
        props[offsetKey] = {
            type: [
                String,
                Number
            ],
            default: null
        };
        return props;
    }, {});
})();
const $4359d614e864bb71$var$orderProps = (()=>{
    return (0, $8MrXO.breakpoints).reduce((props, val)=>{
        const orderKey = 'order' + (0, $327k3.capitalize)(val);
        props[orderKey] = {
            type: [
                String,
                Number
            ],
            default: null
        };
        return props;
    }, {});
})();
const $4359d614e864bb71$var$propMap = {
    col: Object.keys($4359d614e864bb71$var$breakpointProps),
    offset: Object.keys($4359d614e864bb71$var$offsetProps),
    order: Object.keys($4359d614e864bb71$var$orderProps)
};
function $4359d614e864bb71$var$breakpointClass(type, prop, val) {
    let className = type;
    if (val == null || val === false) return undefined;
    if (prop) {
        const breakpoint = prop.replace(type, '');
        className += `-${breakpoint}`;
    }
    if (type === 'col') className = 'v-' + className;
    // Handling the boolean style prop when accepting [Boolean, String, Number]
    // means Vue will not convert <v-col sm></v-col> to sm: true for us.
    // Since the default is false, an empty string indicates the prop's presence.
    if (type === 'col' && (val === '' || val === true)) // .v-col-md
    return className.toLowerCase();
    // .order-md-6
    className += `-${val}`;
    return className.toLowerCase();
}
const $4359d614e864bb71$var$ALIGN_SELF_VALUES = [
    'auto',
    'start',
    'end',
    'center',
    'baseline',
    'stretch'
];
const $4359d614e864bb71$export$8170474963c9327d = (0, $58SaI.propsFactory)({
    cols: {
        type: [
            Boolean,
            String,
            Number
        ],
        default: false
    },
    ...$4359d614e864bb71$var$breakpointProps,
    offset: {
        type: [
            String,
            Number
        ],
        default: null
    },
    ...$4359d614e864bb71$var$offsetProps,
    order: {
        type: [
            String,
            Number
        ],
        default: null
    },
    ...$4359d614e864bb71$var$orderProps,
    alignSelf: {
        type: String,
        default: null,
        validator: (str)=>$4359d614e864bb71$var$ALIGN_SELF_VALUES.includes(str)
    },
    ...(0, $9W37a.makeComponentProps)(),
    ...(0, $dQTee.makeTagProps)()
}, 'VCol');
const $4359d614e864bb71$export$f063fe9fd55e6980 = (0, $jTudE.genericComponent)()({
    name: 'VCol',
    props: $4359d614e864bb71$export$8170474963c9327d(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const classes = (0, $327k3.computed)(()=>{
            const classList = [];
            // Loop through `col`, `offset`, `order` breakpoint props
            let type;
            for(type in $4359d614e864bb71$var$propMap)$4359d614e864bb71$var$propMap[type].forEach((prop)=>{
                const value = props[prop];
                const className = $4359d614e864bb71$var$breakpointClass(type, prop, value);
                if (className) classList.push(className);
            });
            const hasColClasses = classList.some((className)=>className.startsWith('v-col-'));
            classList.push({
                // Default to .v-col if no other col-{bp}-* classes generated nor `cols` specified.
                'v-col': !hasColClasses || !props.cols,
                [`v-col-${props.cols}`]: props.cols,
                [`offset-${props.offset}`]: props.offset,
                [`order-${props.order}`]: props.order,
                [`align-self-${props.alignSelf}`]: props.alignSelf
            });
            return classList;
        });
        return ()=>(0, $327k3.h)(props.tag, {
                class: [
                    classes.value,
                    props.class
                ],
                style: props.style
            }, slots.default?.());
    }
});



var $f7eoJ = parcelRequire("f7eoJ");
let $868ba4e6f5d1fc41$var$script;




let $868ba4e6f5d1fc41$var$initialize = ()=>{
    $868ba4e6f5d1fc41$var$script = (parcelRequire("egk2v"));
    if ($868ba4e6f5d1fc41$var$script.__esModule) $868ba4e6f5d1fc41$var$script = $868ba4e6f5d1fc41$var$script.default;
    $868ba4e6f5d1fc41$var$script.render = (parcelRequire("lObqm")).render;
    $868ba4e6f5d1fc41$var$script.__cssModules = {};
    (parcelRequire("g6RW8")).default($868ba4e6f5d1fc41$var$script);
    $868ba4e6f5d1fc41$var$script.__scopeId = 'data-v-672820';
    $868ba4e6f5d1fc41$var$script.__file = "remote.vue";
};
$868ba4e6f5d1fc41$var$initialize();
var $868ba4e6f5d1fc41$export$2e2bcd8739ae039 = $868ba4e6f5d1fc41$var$script;


const $1722b202ec08308d$var$vuetify = (0, $5Tl4B.createVuetify)({
    components: {
        VApp: $iF5x2.VApp,
        VBtn: $79JPe.VBtn,
        VMain: $4IyVK.VMain,
        VFileInput: $4kufB.VFileInput,
        VTextField: $fsPFg.VTextField,
        VIcon: $cdMxz.VIcon,
        VExpansionPanels: $e307ffff509aed5a$export$1d655deb4215c753,
        VExpansionPanel: $bdced8b715282960$export$ee93fd2a8131fa1c,
        VExpansionPanelTitle: $5f7130367f86d28a$export$4188f36ee8a3fb9e,
        VExpansionPanelText: $61d0772cdd1f944d$export$98a17388a19b123f,
        VCol: $4359d614e864bb71$export$f063fe9fd55e6980,
        VRow: $54e16c7e9e688100$export$978f7f00e11cd63
    },
    icons: {
        defaultSet: 'mdi',
        aliases: $f7eoJ.aliases,
        sets: {
            mdi: $f7eoJ.mdi
        }
    },
    theme: {
        defaultTheme: 'myTheme',
        themes: {
            myTheme: {
                colors: {
                    primary: '#6667ad'
                }
            }
        }
    }
});
(0, $327k3.createApp)((0, $868ba4e6f5d1fc41$export$2e2bcd8739ae039)).use($1722b202ec08308d$var$vuetify).mount('#app');


//# sourceMappingURL=remote.45cb877b.js.map
